import {
    sortAsc
} from '../../../business-components/Sort/Sort'



export const incrementaContPaginaAdicional = ( values ) => {

    if (!values.contPaginaAdicional) {

        values.contPaginaAdicional = 0
    }

    values.contPaginaAdicional += 1
}



export const processaRegistrosDefaultIniciaisPaginaAdicional = ( values ) => {
    
    if (values.paginaAdicional) {
        
        values.paginaAdicional = sortAsc(values.paginaAdicional)
    }
}